import React from 'react';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './Tooltip';
import { TooltipPosition } from './TooltipWrapper';

type TooltipWrapperProps = {
    text?: string;
    component: React.ReactElement;
    className?: string;
    sideOffset?: number;
};

const TooltipWrapperDisabled = ({
    component,
    text = 'You do not have permissions',
    className = '',
    sideOffset = 52,
}: TooltipWrapperProps) => {
    if (!text) return null;

    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <div className={`cursor-not-allowed opacity-50 ${className}`}>{component}</div>
                </TooltipTrigger>
                <TooltipContent
                    side='bottom'
                    sideOffset={sideOffset}
                    className='w-auto max-w-max whitespace-nowrap p-4 text-sm bg-background-alwaysDark text-content-inversePrimary rounded'
                >
                    {text}
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};

TooltipWrapperDisabled.positions = TooltipPosition;

export { TooltipWrapperDisabled };
